import React from 'react';
import { cssMap } from '@compiled/react';

import UFOSegment from '@atlaskit/react-ufo/ufo-segment';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { AgentsWaitingForYourInputLoadable } from './AgentsWaitingForYourInputLoadable.ts';

export const AgentsWaitingForYourInputSection: React.FC = withTransparentErrorBoundary({
	attribution: Attribution.MIGRATIONS_TOOLING,
})((): React.JSX.Element | null => {
	const { isAdminHubAIEnabled, isAIEarlyAccessEnabled } = useSessionData();
	const isEligible =
		isAdminHubAIEnabled &&
		isAIEarlyAccessEnabled &&
		expValEquals('cc_ai_agentic_sessions', 'version', 2);

	return isEligible ? (
		<UFOSegment name="agents-waiting-for-your-input">
			<div css={styles.container}>
				<AgentsWaitingForYourInputLoadable />
			</div>
		</UFOSegment>
	) : null;
});

const styles = cssMap({
	container: {
		gridColumn: '1 / span 1',
	},
});
